import { render, staticRenderFns } from "./UserIntegralOrderDetail.vue?vue&type=template&id=06c94cab&"
import script from "./UserIntegralOrderDetail.vue?vue&type=script&lang=js&"
export * from "./UserIntegralOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./UserIntegralOrderDetail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports